var render = function () {
  var _vm$recruitment, _vm$recruitment2, _vm$recruitment2$comp, _vm$recruitment2$comp2, _vm$recruitment3, _vm$recruitment3$comp, _vm$recruitment3$comp2, _vm$recruitment4, _vm$recruitment4$empl;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', {
    staticClass: "h-100",
    attrs: {
      "elevation": "0",
      "outlined": "",
      "rounded": "lg",
      "to": "/recruitments/".concat((_vm$recruitment = _vm.recruitment) === null || _vm$recruitment === void 0 ? void 0 : _vm$recruitment._id)
    }
  }, [_c('v-layout', {
    attrs: {
      "column": "",
      "justify-space-between": "",
      "fill-height": ""
    }
  }, [_c('div', {
    staticClass: "w-100"
  }, [_c('v-layout', {
    staticClass: "pa-20 pa-md-30 border-bottom",
    attrs: {
      "justify-center": ""
    }
  }, [_c('v-img', {
    staticClass: "w-100",
    attrs: {
      "aspect-ratio": 208 / 60,
      "max-width": "208",
      "contain": "",
      "src": (_vm$recruitment2 = _vm.recruitment) === null || _vm$recruitment2 === void 0 ? void 0 : (_vm$recruitment2$comp = _vm$recruitment2.company) === null || _vm$recruitment2$comp === void 0 ? void 0 : (_vm$recruitment2$comp2 = _vm$recruitment2$comp.logo) === null || _vm$recruitment2$comp2 === void 0 ? void 0 : _vm$recruitment2$comp2.url
    }
  }, [_c('v-fade-transition', [_c('v-overlay', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !((_vm$recruitment3 = _vm.recruitment) !== null && _vm$recruitment3 !== void 0 && (_vm$recruitment3$comp = _vm$recruitment3.company) !== null && _vm$recruitment3$comp !== void 0 && (_vm$recruitment3$comp2 = _vm$recruitment3$comp.logo) !== null && _vm$recruitment3$comp2 !== void 0 && _vm$recruitment3$comp2.url),
      expression: "!recruitment?.company?.logo?.url"
    }],
    attrs: {
      "absolute": "",
      "light": "",
      "color": "white"
    }
  }, [_c('image-overlay', [_vm._v(_vm._s(_vm.recruitment.company.name))])], 1)], 1)], 1)], 1), _c('div', {
    staticClass: "pt-20 pt-md-24 px-20 px-md-24"
  }, [_c('h5', {
    staticClass: "main-recruitment-card__tit page-text--lg font-weight-medium word-keep-all mb-12 mb-lg-20"
  }, [_vm._v(_vm._s(_vm.recruitment.subject))]), _c('p', {
    staticClass: "page-text primary--text mb-4"
  }, [_vm._v(_vm._s(_vm.recruitment.company.name))]), _c('p', {
    staticClass: "page-text mb-8 mb-lg-16"
  }, [_vm._v(_vm._s(_vm.employmentPlace))]), _c('v-chip-group', [_vm._l(((_vm$recruitment4 = _vm.recruitment) === null || _vm$recruitment4 === void 0 ? void 0 : (_vm$recruitment4$empl = _vm$recruitment4.employment) === null || _vm$recruitment4$empl === void 0 ? void 0 : _vm$recruitment4$empl.typesTexts) || [], function (item) {
    return [_c('v-chip', {
      key: item,
      attrs: {
        "outlined": "",
        "color": "grey-d"
      }
    }, [_c('span', {
      staticClass: "grey-6--text"
    }, [_vm._v(_vm._s(item))])])];
  })], 2)], 1)], 1), _c('div', {
    staticClass: "w-100 pb-20 pb-md-24 px-20 px-md-24 mt-8 mt-lg-16"
  }, [_c('v-row', {
    staticClass: "row--small",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', [_c('recruitment-view-application', {
    staticClass: "page-text line-height-1 grey-9--text",
    attrs: {
      "onlyDaysLeft": "",
      "application": _vm.recruitment.application
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('like-btn', {
    attrs: {
      "params": _vm.params__likeBtn
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var active = _ref.active,
          toggle = _ref.toggle;
        return [_c('v-btn', {
          attrs: {
            "icon": "",
            "text": "",
            "small": "",
            "color": active ? 'yellow darken-1' : undefined
          },
          on: {
            "!click": function click($event) {
              $event.stopPropagation();
              $event.preventDefault();
              return toggle($event);
            }
          }
        }, [_c('v-icon', [_vm._v(_vm._s(active ? "mdi-star" : "mdi-star-outline"))])], 1)];
      }
    }])
  })], 1)], 1)], 1)])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }